import { e as E, c as e, s as p, i as t } from "./variables-37cba309-153935bd.js";
var A = function (r) {
  return r[r.DEFAULT = parseInt(E, 10)] = "DEFAULT", r[r.MEDIUM = parseInt(e, 10)] = "MEDIUM", r[r.LARGE = parseInt(p, 10)] = "LARGE", r[r.XLARGE = parseInt(t, 10)] = "XLARGE", r;
}(A || {});
export { A as n };